import "./CourseDetails.css";

import { Link, useParams } from "react-router-dom";
import { courses } from "../components/Courses";
import { useEffect,useState } from "react";

import sessionIcon from "../assets/icons/experians.svg";
import projectIcon from "../assets/icons/projects.svg";
import certificateIcon from "../assets/icons/Certificate.svg";
import portfolioIcon from "../assets/icons/portfolio.svg";
import marketIcon from "../assets/icons/market-job.svg";
import logo from "../assets/logos/stackrize-logo.svg";
import A from "../assets/icons/stackraize.svg";
import leftLight from "../assets/icons/left-light.svg";
import centerLight from "../assets/icons/center-light.svg";
import rightLight from "../assets/icons/right-light.svg";

import instagramIcon from "../assets/icons/instagram-icon.svg";
import facebookIcon from "../assets/icons/facebook-icon.svg";
import emailIcon from "../assets/icons/email-icon.svg";
import whatsappIcon1 from "../assets/icons/whatsapp-icon.svg";
import twitterIcon from "../assets/icons/twitter-icon.svg";
import happyIcon from "../assets/icons/happy.png";
import sadIcon from "../assets/icons/sad.png";
import footerRightLogo from "../assets/logos/footer-right-logo.svg";
import footerLeftLogo from "../assets/logos/footer-left-logo.svg";

import footerEffect from "../assets/icons/footer-effect.svg";
import HomePage from "./HomePage";
export default function CourseDetails() {
const [menuOpen, setMenuOpen] = useState(false);

useEffect(() => {
  const register = document.getElementById("mobile-register");
  const footer = document.querySelector(".footer-section");

  if (!register || !footer) return;

  const handleScroll = () => {
    if (window.innerWidth > 1200) return;

    const footerTop = footer.getBoundingClientRect().top;
    const registerHeight = register.offsetHeight;

    if (footerTop <= window.innerHeight - registerHeight - 12) {
      register.classList.add("stop-register");
    } else {
      register.classList.remove("stop-register");
    }
  };

  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleScroll);

  handleScroll();

  return () => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("resize", handleScroll);
  };
}, []);
  useEffect(() => {
  if (menuOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, [menuOpen]);
const { slug } = useParams();

const course = courses.find(
item=>item.slug===slug
);

if(!course){
return <h1>Course Not Found</h1>
}

return(

<>




<section className="course-details">
                    <nav className="home-navbar">
<div
  className="mobile-menu"
  onClick={() => setMenuOpen(!menuOpen)}
>
  {menuOpen ? "✕" : "☰"}
</div>
<div className="navbar-social">



                <a href="https://www.instagram.com/skillrize2026?igsh=MWdsaXZlcmUzMHdydQ=="  target="_blank"
  rel="noreferrer"> 

                    <img
                        src={instagramIcon}
                        alt=""
                    />

                </a>

            <a href="https://www.facebook.com/share/1H2xWPDneh/"  target="_blank"
  rel="noreferrer">

                    <img
                        src={facebookIcon}
                        alt=""
                    />

                </a>

                <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer">

                    <img
                        src={whatsappIcon1}
                        alt=""
                    />

                </a>

            </div>
        

        <ul className="home-links">
         <Link to="/">
          <li >
            الرئيسية
          </li>
          </Link>

          <Link to="/#courses">
  <li>المسارات</li>
</Link>

<Link to="/#career">
  <li>من نحن</li>
</Link>

<Link to="/#journey">
  <li>الخدمات</li>
</Link>

  <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer"><li>اتصل بنا</li></a>


          

        </ul>

       <div className="home-brand">

          

          <div className="brand-text">

            <span><img src={A}/></span>


          </div>

        </div>
      </nav>
      {menuOpen && (
  <div
    className="mobile-overlay"
    onClick={() => setMenuOpen(false)}
  ></div>
)}
      {menuOpen && (
  <div className="mobile-nav">

    <Link to="/" onClick={() => setMenuOpen(false)}>
      الرئيسية
    </Link>

    <Link to="/#courses" onClick={() => setMenuOpen(false)}>
  المسارات
</Link>

<Link to="/#career" onClick={() => setMenuOpen(false)}>
  من نحن
</Link>

<Link to="/#journey" onClick={() => setMenuOpen(false)}>
  الخدمات
</Link>

  <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer"><li>اتصل بنا</li></a>


    <div className="mobile-social">

                      <a href="https://www.instagram.com/skillrize2026?igsh=MWdsaXZlcmUzMHdydQ=="  target="_blank"
  rel="noreferrer">        <img src={instagramIcon} alt="" />
      </a>

      <a href="https://www.facebook.com/share/1H2xWPDneh/"  target="_blank"
  rel="noreferrer">
        <img src={facebookIcon} alt="" />
      </a>

                      <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer">

                    <img
                        src={whatsappIcon1}
                        alt=""
                    />

                </a>

    </div>

  </div>
)}

      <img src={leftLight} className="bg-light1 left-light1" alt="" />

<img src={rightLight} className="bg-light right-light1" alt="" />
<div className="course-wrapper">
<div className="course-sidebar">

<div className="course-info-card">

<div className="info-row">
<span>نظام التدريب</span>
<strong>{course.trainingType}</strong>
</div>

<div className="info-row">
<span>عدد المستويات</span>
<strong>{course.levels}</strong>
</div>

<div className="info-row">
<span>مدة الكورس</span>
<strong>{course.duration}</strong>
</div>

<div className="info-row">
<span>عدد الساعات</span>
<strong>{course.hours}</strong>
</div>

<div className="info-row price">
<span>السعر الكامل</span>
<strong>{course.price}</strong>
</div>

<p className="payment-note">
40% دفعة أولى والباقي أثناء فترة التدريب
</p>

</div>
<div className="register-card" id="mobile-register">
      <div className="register-glow"></div>

<div className="register-header">
    <h3>ابدأ معنا الآن</h3>

    <p>
      التسجيل سيكون من خلال الواتساب
    </p>
  </div>

<a
href="https://wa.me/963942590274"
target="_blank"
rel="noreferrer"
className="register-btn"
>

سجل الآن

</a>

<span className="small-note">

ملحوظة سارع بالتسجيل لان الاماكن محدودة .
</span>

</div>
<div className="download-card">

<h3>

لو حابب تشوف تفاصيل اكثر عن الكورس نزل الملف المجاني :
</h3>

<a

href={course.pdf}

download

className="download-btn"

>


تحميل الملف المجاني

</a>

</div>

</div>
<div className="course-content">

    <div className="course-main-card">

        <div className="course-title">

            <div className="course-title-right">

                <img
                    src={course.icon}
                    alt={course.title}
                />

                <h1>
                    كورس {course.title}
                </h1>

            </div>

        </div>

        <p className="course-description">

            {course.description}

        </p>

        <h3 className="features-title">

            ماذا ينتظرك؟

        </h3>

        <div className="course-features">
<div className="feature-card">

    <img
        src={certificateIcon}
        alt=""
    />

    <span>

        {course.certificate}

    </span>

</div>
<div className="feature-card">

    <img
        src={projectIcon}
        alt=""
    />

    <span>

        {course.projects}

        مشاريع

    </span>

</div>

<div className="feature-card">

    <img
        src={sessionIcon}
        alt=""
    />

    <span>

        {course.sessions}

        جلسة

    </span>

</div>
<div className="feature-card">

    <img
        src={portfolioIcon}
        alt=""
    />

    <span>

        {course.portfolio}

    </span>

</div>
<div className="feature-card">

    <img
        src={marketIcon}
        alt=""
    />

    <span>

        {course.jobReady}

    </span>

</div>
        </div>

    </div>
<div className="teacher-card">

    <h2>

        المدرب

    </h2>

<div className="teacher-top">
<div className="teacher-header">
        <img
            src={course.instructor.image}
            alt=""
            className="teacher-image"
        />

        <div>
            <h3>{course.instructor.name}</h3>
            <span>{course.instructor.job}</span>
        </div>
    </div>

    <div className="teacher-social">
        {course.instructor.social?.map((item, index) => (
            <a
                key={index}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="social-btn"
            >
                <img src={item.icon} alt="" />
            </a>
        ))}
    </div>

    

</div>

<p>{course.instructor.description}</p>

    </div>
    <div className="mobile-course-details">
        
<div className="course-info-card">

<div className="info-row">
<span>نظام التدريب</span>
<strong>{course.trainingType}</strong>
</div>

<div className="info-row">
<span>عدد المستويات</span>
<strong>{course.levels}</strong>
</div>

<div className="info-row">
<span>مدة الكورس</span>
<strong>{course.duration}</strong>
</div>

<div className="info-row">
<span>عدد الساعات</span>
<strong>{course.hours}</strong>
</div>

<div className="info-row price">
<span>السعر الكامل</span>
<strong>{course.price}</strong>
</div>

<p className="payment-note">
40% دفعة أولى والباقي أثناء فترة التدريب
</p>

</div>
<div className="download-card">

<h3>

لو حابب تشوف تفاصيل اكثر عن الكورس نزل الملف المجاني :
</h3>

<a

href={course.pdf}

download

className="download-btn"

>


تحميل الملف المجاني

</a>

</div>
    </div>
<section className="why-section">

  <h2 className="why-title">
    لماذا ستبدأ معنا؟
  </h2>

  <div className="before-after">

    <div className="why-card before-card">

      <div className="card-header">
        
        <span className="card-label before-label">قبل</span>
        <img src={sadIcon} className="card-icon"/>
      </div>

      <div className="card-list">
        {course.before.map((item, index) => (
          <div key={index} className="card-item">
            {item}
          </div>
        ))}
      </div>

    </div>

    <div className="why-card after-card">

      <div className="card-header">
        <span className="card-label after-label">بعد</span>
        <img src={happyIcon} className="card-icon"/>
        
      </div>

      <div className="card-list">
        {course.after.map((item, index) => (
          <div key={index} className="card-item">
            {item}
          </div>
        ))}
      </div>

    </div>

  </div>

</section>
    </div>
</div>
  </section>
<section className="footer-section">

    <img
        src={footerLeftLogo}
        alt=""
        className="footer-side-logo left"
    />

    <img
        src={footerRightLogo}
        alt=""
        className="footer-side-logo right"
    />

    <img
        src={footerEffect}
        alt=""
        className="footer-effect"
    />

    <div className="footer-content">

        <h2>

           .كل خبير كان مبتدئاً يوماً... ابدأ رحلتك معنا

        </h2>

        <p>

           ،نؤمن أن التعلم هو بداية كل نجاح 

            <br />

           .ونسعى لتقديم تجربة تعليمية عملية تُمهّد طريقك نحو مستقبل مهني أفضل

        </p>

  <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer">        <button className="footer-btn">

           تواصل معنا

        </button>
        </a>

        <div className="footer-divider"></div>

        <div className="footer-bottom">

            <div className="home-brand">
              

                <div className="brand-text">

                    <span>

                        <img src={A} alt="" />

                    </span>

                    

                </div>

                

            </div>

            <ul className="footer-links">

                

                <Link to="/#faq"><li>الأسئلة الشائعة</li></Link>

                <Link to="/#certificate"><li>الشهادة</li></Link>

                          <Link to="/#courses">
  <li>المسارات</li>
</Link>

<Link to="/#career">
  <li>من نحن</li>
</Link>

                <Link to="/#hero"><li>الرئيسية</li></Link>

            </ul>

                        <div className="footer-social">

                

                <a href="https://wa.me/963982749102 "  target="_blank"
  rel="noreferrer">

                    <img
                        src={whatsappIcon1}
                        alt=""
                    />

                </a>
            <a href="https://www.facebook.com/share/1H2xWPDneh/"  target="_blank"
  rel="noreferrer">

                    <img
                        src={facebookIcon}
                        alt=""
                    />

                </a>
                <a href="https://www.instagram.com/skillrize2026?igsh=MWdsaXZlcmUzMHdydQ=="  target="_blank"
  rel="noreferrer"> 

                    <img
                        src={instagramIcon}
                        alt=""
                    />

                </a>



            </div>

        </div>

    </div>

</section>


  </>
);
}